import { PbRestockDTO } from '@itsrever/rever-api'
import { RestockItem } from '@/domain/restock'

export function toRestock(restocks: PbRestockDTO[]): RestockItem[] {
  const domainRestocks: RestockItem[] = restocks.map((restock) => ({
    lineItemId: restock.line_item_id ?? '',
    quantity: restock.quantity ?? 1,
    status: 'RESTOCKED'
  }))
  return domainRestocks ?? []
}
